module.exports = __webpack_public_path__ + "img/ico-info-active.448ecd34.png";